import React from 'react'
// libs
import styled from 'styled-components'
import { FieldArray } from 'redux-form'
// components
import Rows from '../Rows'
import ColumnPlaceholder from './components/ColumnPlaceholder'
// hooks
import { useColumnsHeight } from '../hooks'
import { useCurrentForm, useCurrentTable } from 'hooks/risks'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// views
import { RowsWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableForm/components/Rows/views'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${RowsWrapper} {
    > div {
      padding: 4px;
    }
  }
`

/** Render content (column) for primary fieldLink which groupedBy current template */

const Column: React.FC = () => {
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const { fieldLink } = useCurrentForm()
  const { groupingMap } = useCurrentTable()

  const { ref } = useColumnsHeight(fieldLink)

  // Collect all column IDs that co-appear with the current column in any multi-groupBy array
  // and have an earlier position — each needs a visual placeholder rendered above the current column
  const prevColumnIds = React.useMemo(() => {
    const coGroupedIds = new Set<string>()

    for (const item of groupingMap) {
      if (item.groupedBy.length > 1 && item.groupedBy.includes(fieldLink.id)) {
        for (const id of item.groupedBy) {
          if (id !== fieldLink.id) {
            coGroupedIds.add(id)
          }
        }
      }
    }

    return riskTemplate.fieldLinks
      .filter((fl) => coGroupedIds.has(fl.id) && fl.position < fieldLink.position)
      .sort((a, b) => a.position - b.position)
      .map((fl) => fl.id)
  }, [groupingMap, fieldLink.id, fieldLink.position, riskTemplate.fieldLinks])

  return (
    <>
      {prevColumnIds.map((columnId) => (
        <ColumnPlaceholder key={columnId} columnId={columnId} />
      ))}

      <Wrapper ref={ref}>
        <FieldArray name={fieldLink.id} component={Rows} />
      </Wrapper>
    </>
  )
}

export default Column
